// Simple sortable-by-column-order table for measures whose rows
// don't fit a single number or bar list. Column headers come from
// the first row's keys.

interface Props {
  rows: Record<string, unknown>[];
}

const fmt = new Intl.NumberFormat('en-AU');

function render(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'number') return fmt.format(value);
  return String(value);
}

export function DataTable({ rows }: Props) {
  const keys = Object.keys(rows[0] ?? {});

  return (
    <div className="data-table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {keys.map((k) => (
              <th key={k}>{k}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {keys.map((k) => (
                <td key={k}>{render(row[k])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  );
}

const styles = `
.data-table-wrap { width: 100%; overflow-x: auto; }
.data-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.data-table th, .data-table td { text-align: left; padding: 8px 10px; border-bottom: 1px solid var(--ac-grey-100); }
.data-table th { font-weight: 600; color: var(--ac-grey-700); background: var(--ac-grey-50); }
.data-table tr:last-child td { border-bottom: 0; }
`;
